import React from "react";

import ErrorIcon from "../../Common/svg/messages/error";

const ErrorMessage = ({ message, details, onRetry }) => {
  const displayMessage = message || "يوجد خطأ ما...";
  const displayDetails = details || "يرجي إعادة المحاولة...";

  return (
    <div className="text-center d-flex flex-column justify-content-center align-items-center">
      <div
        style={{
          width: "64px",
          height: "64px",
          display:"flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#FFF7BA",
          borderRadius:"50%"
        }}
      >
        <ErrorIcon />  
      </div>
      <h4 className="font800 mt-3">يوجد خطأ ما</h4>
      <p className="desc">يرجي إعادة المحاولة...</p>
      {onRetry && (
        <button 
          className="btn btn-primary mt-2"
          onClick={onRetry}
          style={{
            backgroundColor: "#FFCC03",
            borderColor: "#FFCC03",
            borderRadius: "8px",
            padding: "8px 16px",
            fontSize: "14px"
          }}
        >
          إعادة المحاولة
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
